import { render } from "./PaymentTopUpHistoryTable.vue?vue&type=template&id=fa2f13a2"
import script from "./PaymentTopUpHistoryTable.vue?vue&type=script&lang=js"
export * from "./PaymentTopUpHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__